import { useOutletContext } from 'react-router-dom'
import { ProgramPurseResource } from '@/queries/program_purses/schemas.ts'
import { PartialPurseData } from '../types'
import AffiliationRestrictionCard from '../shared/AffiliationRestrictionCard'
import PurseBankAccountCard from '../shared/PurseBankAccountCard'
import AutoDistributionCard from '../shared/AutoDistributionCard'

interface OutletContext {
  purse: ProgramPurseResource
}

export function DistributionSettingsTabLoader() {
  const { purse } = useOutletContext<OutletContext>()

  const partialPurseData: PartialPurseData = {
    id: purse.id,
    programId: purse.program_id,
    canDistributeAutomatically: purse.can_distribute_funds_automatically,
    affiliationRestrictionEnabled: purse.affiliation_restriction_enabled,
    bankAccountId: purse.bank_account_id,
  }

  return (
    <div className="space-y-6">
      <AutoDistributionCard partialPurseData={partialPurseData} />
      <AffiliationRestrictionCard partialPurseData={partialPurseData} />
      <PurseBankAccountCard partialPurseData={partialPurseData} />
    </div>
  )
}
